import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import WelcomeScreen from "./pages/WelcomeScreen";
import Dashboard from "./pages/Dashboard";
import Media from "./pages/Media/Media";
import Playlists from "./pages/Playlists";
import Playlist from "./pages/Playlist"; // New Playlist Page
import Layouts from "./pages/Layouts";
import Schedules from "./pages/Schedules";
import Screens from "./pages/Screens";
import Content from "./pages/Content";
import Sidebar from "./components/Sidebar";
import LoginPage from "./pages/LoginPage";
import NewSchedule from "./pages/NewSchedule"; // ✅ Ensure this is correctly imported

import Loader from "./components/Loader";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const hideSidebarRoutes = ["/", "/welcome"];
  const isSidebarHidden = hideSidebarRoutes.includes(window.location.pathname);

  return (
    <div style={{ display: "flex" }}>
      {!isSidebarHidden && <Sidebar />}
      <div
        style={{
          marginLeft: isSidebarHidden ? "0" : "200px",
          padding: "20px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route
              path="/welcome"
              element={
                <ProtectedRoute>
                  <WelcomeScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/media/*"
              element={
                <ProtectedRoute>
                  <Media />
                </ProtectedRoute>
              }
            />
            <Route
              path="/playlists"
              element={
                <ProtectedRoute>
                  <Playlists />
                </ProtectedRoute>
              }
            />
            <Route
              path="/layouts"
              element={
                <ProtectedRoute>
                  <Layouts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/schedules"
              element={
                <ProtectedRoute>
                  <Schedules />
                </ProtectedRoute>
              }
            />
            <Route
              path="/screens"
              element={
                <ProtectedRoute>
                  <Screens />
                </ProtectedRoute>
              }
            />
            <Route
              path="/content"
              element={
                <ProtectedRoute>
                  <Content />
                </ProtectedRoute>
              }
            />
            <Route
  path="/playlist"
  element={
    <ProtectedRoute>
      <Playlist />
    </ProtectedRoute>
  }
/>
<Route path="/playlist/:id" element={<Playlist />} /> {/* ✅ Fixes the edit issue */}
<Route path="/new-schedule" element={<NewSchedule />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}

export default App;
